import { baseApi } from '@klp/core/api';
import { generateApiRoute } from '@klp/core/api/helpers';

import {
    messageApiName,
    notificationApiName,
    sendSampleApiName,
} from './../api';

export const messageApi = baseApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (build) => ({
        postSendSample: build.mutation<
            void,
            { messageId: number; email?: string; culture?: string }
        >({
            query: ({ messageId, email, culture }) => ({
                url: generateApiRoute([
                    messageApiName,
                    notificationApiName,
                    sendSampleApiName,
                    messageId,
                ]),
                params: {
                    email,
                    culture,
                },
                method: 'POST',
            }),
            extraOptions: {},
        }),
    }),
});

export const { usePostSendSampleMutation } = messageApi;
